import BaseAPI from '@/apis/base/baseApi';

class DevicePortAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'devicePort';
}

export default new DevicePortAPI();
